import styled from 'styled-components'

const MyDiv = styled.div`
.table_header th {
  position: sticky;
  top: 0;
  background: #fff;   
  z-index: 1;          
}
 .startDate {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    white-space: nowrap; 
    cursor: pointer;
  }

.flex_header{
    align-items: center;
    justify-content: space-between;
}
.overview_card {
  border-radius: 10px;
  padding: 12px;
  margin-top: 10px;
}
.green {
  background-color: #D0FAE6;
}
.orange {
  background-color:#FFEED4;
}

.status-label {
  font-size: 10px;
  margin-top: 14px;
  padding: 2px 6px;
  border-radius: 6px;
  display: inline-block;
  white-space: nowrap;
}

 .status_badge {
  padding: 5px 15px;
  font-size: 12px;
  font-weight: 500;
  color: #008000;
}

  .status_badge.green {
    color: #15803d;
  }

  .status_badge.red {
    color: #b91c1c;
  }

  .status_badge.orange {
    color: #c2410c;
  }

  .status_badge.blue {
    color: #0369a1;
  }

  .status_badge.purple {
    color: #6d28d9;
  }
  .status_badge.pink {
    color: #b4288aff;
  }
  .status_badge.yellow {
    color: #f4ca0eff;
  }
    .status_badge.cyan {
  color: #00bcd4;              
}

.status_badge.teal {
  color: #0f766e;
}

.status_badge.amber {
  color: #b45309;
}
`
export default MyDiv
